import React, { Fragment, Suspense } from "react";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle";
import Footer from "./Common/Footer";
import Home from "./Component/Home/Home";
import NotFoundPage from "./Common/404";
import Header from "./Common/Header";
import IndependenceDayOfferpage from "./Component/Home/IndependenceDayOffer";

function App() {
  return (
    <BrowserRouter>
      <Suspense
      // fallback={<MainLoader />}
      >
        <Routes>
          <Route
            path="/ticket-management-independence-day-campaign"
            exact
            element={
              <Fragment>
                <Header/>
                <Home />
                <Footer />
              </Fragment>
            }
          />
           <Route
            path="/review-management-feature-friday-campaign"
            exact
            element={
              <Fragment>
                <Header/>
                <IndependenceDayOfferpage />
                <Footer />
              </Fragment>
            }
          />
         
           {/* <Route path="/404" element={<NotFoundPage/>} /> */}
           {/* <Route path="*" element={<Navigate to='/404' replace />} /> */}
           <Route path="*" element={<Navigate to='/ticket-management-independence-day-campaign' replace />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}

export default App;


